document.addEventListener('alpine:init', () => {
  Alpine.data('rosterGrid', (config) => ({
    search: '',
    selectedFilter: '',
    filterOpen: false,
    currentPage: 1,
    perPage: config.perPage || 6,
    athletes: [],

    init() {
      const el = document.getElementById('roster-data-' + config.sectionId);
      if (el) this.athletes = JSON.parse(el.textContent);
    },

    get filters() {
      return [...new Set(this.athletes.map(a => a.role).filter(Boolean))];
    },

    get filtered() {
      return this.athletes.filter(a => {
        const nameMatch = !this.search || a.name.toLowerCase().includes(this.search.toLowerCase());
        const roleMatch = !this.selectedFilter || a.role === this.selectedFilter;
        return nameMatch && roleMatch;
      });
    },

    get totalPages() {
      return Math.ceil(this.filtered.length / this.perPage);
    },

    get pageNumbers() {
      return Array.from({ length: this.totalPages }, (_, i) => i + 1);
    },

    get pagedIndices() {
      const start = (this.currentPage - 1) * this.perPage;
      return new Set(this.filtered.slice(start, start + this.perPage).map(a => a.index));
    },

    isVisible(index) {
      return this.pagedIndices.has(index);
    },

    resetPage() {
      this.currentPage = 1;
    },

    goToPage(p) {
      if (p >= 1 && p <= this.totalPages) this.currentPage = p;
    },

    selectFilter(f) {
      this.selectedFilter = f;
      this.filterOpen = false;
      this.resetPage();
    },

    clearFilters() {
      this.search = '';
      this.selectedFilter = '';
      this.filterOpen = false;
      this.resetPage();
    }
  }));
});
